import { MeterEntity } from "@ots-frontend/ots-data";
import { useCallback } from "react";
import { BaseEntitySelect, BaseEntitySelectProps } from "../base-entity-select";

export type BaseMeterSelectProps = Omit<
  BaseEntitySelectProps<MeterEntity>,
  'nameMapper'
>;

export const BaseMeterSelect = (props: BaseMeterSelectProps) => {
  const nameMapper = useCallback((e: MeterEntity) => {
    return e.name;
  }, []);

  return <BaseEntitySelect nameMapper={nameMapper} {...props} />;
};
